import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { BrandHeading } from "@/components/BrandFrame";

export default function AdminAuditPage() {
  const auditQ = useQuery({ queryKey: ["audit"], queryFn: () => api.audit() });

  return (
    <div className="space-y-4">
      <BrandHeading>บันทึกกิจกรรม</BrandHeading>
      <Card>
        <CardHeader>
          <CardTitle>กิจกรรมแอดมินล่าสุด</CardTitle>
        </CardHeader>
        <CardContent className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-left text-xs uppercase text-muted-foreground">
              <tr><th className="pb-2">เวลา</th><th>โดย</th><th>การกระทำ</th><th>เป้าหมาย</th><th>รายละเอียด</th></tr>
            </thead>
            <tbody>
              {(auditQ.data?.entries ?? []).map((e: any) => (
                <tr key={e.id} className="border-t border-border/50 align-top">
                  <td className="py-2 text-xs text-muted-foreground">{new Date(e.created_at).toLocaleString("th-TH")}</td>
                  <td className="text-xs font-mono">{e.actor_username ?? "—"}</td>
                  <td><Badge>{e.action}</Badge></td>
                  <td className="font-mono text-xs">{e.target_type}{e.target_id ? `·${e.target_id}` : ""}</td>
                  <td className="max-w-md truncate text-xs text-muted-foreground" title={e.after_json ?? e.before_json ?? ""}>
                    {(e.after_json ?? e.before_json ?? "").slice(0, 200)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>
  );
}
